import { Navigate } from "react-router";
import { doLogout } from "@/lib/helpers";

export default function Logout() {
    doLogout();

    return (
        <Navigate to="/" />
    )
}